import CONST from '../../assets/js/const'

export default {
    namespaced: true,
    state: () => ({
        painter: null,
        brush_size: 30,
        paint_mode: CONST.PAINT_MODE_BRUSH,
        paint_type: CONST.PAINT_FREE_HAND
    }),
    mutations: {
        setPainter: (state, painter) => state.painter = painter,
        setBrushSize: (state, brush_size) => state.brush_size = brush_size,
        setPaintMode: (state, paint_mode) => state.paint_mode = paint_mode,
        setPaintType: (state, paint_type) => state.paint_type = paint_type,
    },
    getters: {
        paint_config: state => ({
            brush_size: state.brush_size,
            paint_mode: state.paint_mode,
            paint_type: state.paint_type
        })
    },
    actions: {
        async setClippingImage({ state, commit, dispatch }, img_el) {

            state.painter.setImage(img_el);
            const img = await state.painter.getImage();
            commit('setClippingImage', img, {root: true});
        }
    }
}

